import { basePath, viewPath, docPath, resultsPath } from './franklyNetHost';

const suffix = (query) => (query ? `&q=${encodeURIComponent(query)}` : '');

export const isFrameDoc = (value) => {
    const target = String(value || '');
    return target.startsWith('/') && !target.startsWith('//');
};

export const frameDoc = (path, query) =>
    `${viewPath()}?doc=${encodeURIComponent(path)}${suffix(query)}`;

export const frameUrl = (url, query) =>
    `${viewPath()}?url=${encodeURIComponent(url)}${suffix(query)}`;

export const frameArticle = ({ slug, habboId }, query) =>
    (habboId
        ? frameDoc(`/community/article/${habboId}/${slug}`, query)
        : frameDoc(docPath('article', slug), query));

export const frameEntity = (slug, query) =>
    frameDoc(docPath('entity', slug), query);

export const frameAny = (target, query) =>
    (isFrameDoc(target) ? frameDoc(target, query) : frameUrl(target, query));

export const searchPath = (query) => resultsPath(query);

export const netBasePath = () => basePath();
